module.exports = __webpack_public_path__ + "static/img/022_TO8_1508.64b558f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/022_TO8_1508.jpg
// module id = B+0n
// module chunks = 0